import React from 'react';
import Routes from './routes';
import { Header } from "@company-mrv/mrv-design-system/components";
import { Menu, Notification } from "@company-mrv/mrv-design-system/icons";

function App() 
{
  return (
    <>
      <Header logoHref="/dashboard">
        <Notification className="icone-notificacao" a11yTitle="" />
          <Menu className="icone-menu" a11yTitle="" />
      </Header>
      <Routes />
    </>
  );
}

export default App;
